import React, { useEffect, useState } from "react";
import { Table, Dropdown, Menu, message, Modal as AntModal } from "antd"; 
import { useNavigate } from "react-router-dom";
import { BsThreeDots } from "react-icons/bs";
import { FaPlus } from "react-icons/fa6";
import { Modal as BootstrapModal } from "react-bootstrap"; //  
import Instance from "../../AxiosConfig";
import AddStandardModal from "./AddStandard";
import EditStandardModal from "./EditStandard";
import ViewStandardModal from "./ViewStandard";
 
 


const StandardTable = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const itemsPerPage = 100;
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const handleModalClick = (key, record) => {
    setSelectedData(record); // store selected agent

    if (key === "view") {
      setShowViewModal(true);
    } else if (key === "edit") {
      setShowEditModal(true);
    } else if (key === "delete") {
     confirmDelete(record); 
    }
  };

  const menu = (record) => (
    <Menu
      onClick={({ key }) => handleModalClick(key, record)} // pass record here too
      className="custom-dropdown-menu"
    >
      <Menu.Item key="view">View</Menu.Item>
      <Menu.Item key="edit">Edit</Menu.Item>
      <Menu.Item key="delete">Delete</Menu.Item>
    </Menu>
  );

  const fetchData = async (page = 1) => {
    setLoading(true);
    const token = localStorage.getItem("token");
    try {
      const response = await Instance.get("/standards", {
        params: { page, limit: itemsPerPage },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200 || response.status === 201) {
        setData(response?.data?.standards || []);
        console.log("Fetched Standards:", response?.data?.standards);
      }
    } catch (error) {
      console.log(error.response);
    } finally {
      setLoading(false);
    }
  };

 const confirmDelete = (record) => {
  AntModal.confirm({
    title: "Are you sure you want to delete this standard?",
    content: "This action cannot be undone.",
    okText: "Yes, Delete",
    okType: "danger",
    cancelText: "Cancel",
    centered: true,
    onOk: () => deleteData(record._id),
  });
};


// ✅ Delete the selected record by ID
const deleteData = async (id) => {
  const token = localStorage.getItem("token");
  try {
    const response = await Instance.delete(`/standards/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 204) {
      message.success("Standard deleted successfully!");
      fetchData(currentPage); // refresh the table
    } else {
      message.error("Failed to delete standard.");
    }
  } catch (error) {
    console.error(error);
    message.error("Something went wrong while deleting.");
  }
};

  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    {
      title: "Standard Name",
      dataIndex: "standardName",
    },
    {
      title: "Description ",
      dataIndex: "description",
    },

    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Dropdown
          overlay={menu(record)}
          trigger={["click"]}
          placement="bottomRight"
        >
          <BsThreeDots style={{ fontSize: "20px", cursor: "pointer" }} />
        </Dropdown>
      ),
    },
  ];

  return (
    <div>
      <div className="agents-page mt-5">
        <div className="agents-table mt-3">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="agents-heading-h1">Standards List</h1>
            <div className="d-flex align-items-center gap-3 table-header-buttons">
              <button className="surve-export-btn" onClick={handleShow}>
                <FaPlus /> Add New Standard
              </button>
            </div>
          </div>
          <div className="mt-4">
            <Table
              columns={columns}
              dataSource={data}
              loading={loading}
              pagination={{
                pageSize: itemsPerPage,
                current: currentPage,
                onChange: (page) => setCurrentPage(page),
                className: "custom-pagination",
              }}
              scroll={{ x: "max-content" }}
            />
          </div>
        </div>
      </div>
      <AddStandardModal
        show={showModal}
        handleClose={handleClose}
        fetchData={fetchData}
      />
      <ViewStandardModal
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        agentData={selectedData}
        fetchData={fetchData}
      />

      <EditStandardModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        agentData={selectedData}
        fetchData={fetchData}
      />
    </div>
  );
};

export default StandardTable;
